require('lodash');
require('moment');
require('angular');
require('angular-readable-time');
require('angular-ellipsis');

const authModule = require('gw-um-auth/authModule.js');
const coreModule = require('gw-um-core/coreModule.js');
const headerModule = require('gw-um-header/headerModule.js');
const gridDataBrowserModule = require('gw-um-grid-data-browser/gridDataBrowserModule.js');
const emailEditorModule = require('gw-um-email-editor/emailEditorModule.js');
const extensions = require('gw-um-extensions/extensionsModule.js');

angular.module('ums', [
    coreModule,
    authModule,
    'ums.configuration',
    headerModule,
    gridDataBrowserModule,
    emailEditorModule,
    extensions
])
    .constant('umStudioConstant', {
        event: {
            BULK_FORM_TEMPLATE_EXPORT: 'formTemplate.BulkFormTemplateExport',
            BULK_FORM_TEMPLATE_EXPORT_COMPLETE: 'formTemplate.BulkFormTemplateExportComplete',
            BULK_FORM_TEMPLATE_MARK_IN_PRODUCTION: 'formTemplate.BulkFormTemplateMarkInProduction',
            BULK_FORM_TEMPLATE_MARK_IN_PRODUCTION_COMPLETE: 'formTemplate.BulkFormTemplateMarkInProductionComplete',
            FOCUS_ON_RULE_NAME: 'ruleBuilder.FocusOnRuleName',
            RULE_UPDATED: 'ruleBuilder.RuleUpdated',
            RULE_STATUS_UPDATED: 'ruleBuilder.RuleStatusUpdated',
            RULE_VARIABLE_VALUE_CHANGED: 'ruleBuilder.RuleVariableValueChanged',
            FIELD_RULE_SELECTED: 'formTemplate.ruleBuilder.FieldRuleSelected',
            FORM_RULE_SELECTED: 'formTemplate.ruleBuilder.FormRuleSelected',
            RESET_RULE_SELECTION: 'formTemplate.ruleBuilder.ResetRuleSelection',
            CREATE_NEW_FIELD_RULE: 'formTemplate.ruleBuilder.CreateNewFieldRule'
        }
    })
    .config(function () {})
    .run(function (appTypeConfigurationModel, coreConstant) {
        appTypeConfigurationModel.setConsoleType(coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO);
    })
    .baseURL = './';

require('./applicationController.js');
require('./app.less');
require('./common/businessCard/uiBusinessCard.js');
require('./common/header/appHeader.i18n.json');
require('./common/header/appHeader.tpl.html');
require('./common/header/appHeaderController');

require('./configuration/configurationModule.js');





